import React from "react"
import SEO from "../components/seo"
import Video from "../components/Video"
import VideoMobile from "../components/VideoMobile"

export default function CatusjackPage(props) {
  return (
    <div id="nike-cactus-jack">
      <VideoMobile
        title="Nike x Cactus Jack, AF-1 • Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1234407562?&title=0&muted=0"
        allowsInlineMediaPlayback="true"
      />
      <Video
        title="Nike x Cactus Jack, AF-1 • Directed by Arnaud Bresson"
        src="https://player.vimeo.com/video/1234407562?background=1&autoplay=1&loop=1&byline=0&title=0&muted=0"
      />
      <SEO title={props.title} />
    </div>
  )
}
